import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BankDetails, BankDetailsClient, Kasa, KasaClient} from "src/app/web-api-client";
import { WtStorageService } from "../../../wt-storage.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";
import { BankDetailsStatus } from "../../../enums/bankDetails.enum";

@Component({
  selector: 'app-bank-account-add',
  templateUrl: './bank-account-add.component.html',
  styleUrls: ['./bank-account-add.component.scss']
})
export class BankAccountAddComponent implements OnInit  {

  public isLoaded = true;
  public services: BankDetails[];
  public onClose: Subject<void> = new Subject();

  public selectedStatus: BankDetailsStatus = BankDetailsStatus.Standard; // Default selection

  // Convert Enum to Array for *ngFor
  public statuses = Object.keys(BankDetailsStatus)
    .filter(key => !isNaN(Number(BankDetailsStatus[key])))
    .map(key => ({ name: key, value: BankDetailsStatus[key] }));

   Form: FormGroup;

  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public wtStore:WtStorageService,public client:BankDetailsClient ) { }

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm() {
    this.Form = this.fb.group({
      title: ['', Validators.required],
      dataReg: [new Date(), Validators.required],
      iban: ['', Validators.required],
      bic: ['', Validators.required],
      status: [0, Validators.required],
    });
  }

  closeModal() {
    this.onClose.next();
    this.activeModal.close();
  }

  onSubmit() {
    if (this.Form.valid) {

      let service =new BankDetails();

      service.idBankDetails = 0;
      service.title = this.Form.value.title;
      service.dataReg = this.Form.value.dataReg;
      service.iban = this.Form.value.iban;
      service.bic = this.Form.value.bic;
      service.status = this.selectedStatus;
      service.operatorId = this.wtStore.getuser().id;
      service.organizationId = this.wtStore.getuser().organizationId;

      this.client.create(service).subscribe((user)=>{

        this.onClose.next();
        this.activeModal.close();
      });
    }
  }

}
